import React from "react";
import { useTranslation } from "react-i18next";
import VoiceSampleModal from "./voice-sample-modal/VoiceSampleModal";
import downloadIcon from "../../../../../../assets/png/download-no-bg.png";
import printingIcon from "../../../../../../assets/png/printing-transparent.png";
import audiobookIcon from "../../../../../../assets/png/audiobook-no-bg.png";
import "./ActionButtons.css";

const ActionButtons = ({
  loading,
  isPaid,
  onClickGenerateAudiobook,
  onClickDownloadBook,
  onClickGetPrintedBook,
  handleVoiceUploaded,
}) => {
  const { t } = useTranslation();

  return (
    <div className="action-buttons-container">
      <div className="action-buttons-wrapper">
        {/* Download Book Button */}
        <button
          className="action-btn action-btn-outline"
          disabled={loading || !isPaid}
          onClick={onClickDownloadBook}
        >
          <img src={downloadIcon} alt="Download" width={24} height={24} />
          {t("download_book")}
        </button>

        {/* Get Audio Book Button */}
        <button
          className="action-btn action-btn-primary"
          disabled={loading || !isPaid}
          onClick={onClickGenerateAudiobook}
        >
          <img src={audiobookIcon} alt="Audiobook" width={24} height={24} />
          {t("get_audio_book")}
        </button>

        {/* Get Printed Book Button */}
        <button
          className="action-btn action-btn-dark"
          disabled={loading || !isPaid}
          onClick={onClickGetPrintedBook}
        >
          <img src={printingIcon} alt="Print" width={24} height={24} />
          {t("get_printed_book")}
        </button>
      </div>

      <VoiceSampleModal
        id="voice-sample-modal"
        onUploaded={handleVoiceUploaded}
      />
    </div>
  );
};

export default ActionButtons;
